import Vue from 'vue';
import {
  Toast,
  Lazyload,
  Swipe,
  SwipeItem,
  Button,
  Tag,
  Tab,
  Tabs,
  Form,
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Icon,
} from 'vant';
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Tag);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Icon);
Vue.use(Lazyload, { lazyComponent: true });

